const dealershipDomains: Record<string, string> = {
  'carvanacdjratlanta.com': 'Atlanta, GA',
  'carvanacdjrboston.com': 'Boston, MA',
  'carvanacdjrcasagrande.com': 'Casa Grande, AZ',
  'carvanacdjrcleveland.com': 'Avon Lake, OH',
  'carvanacdjrparkcities.com': 'Park Cities, TX',
  'carvanacdjrsacramento.com': 'Sacramento, CA',
  'carvanacdjrsandiego.com': 'San Diego, CA'
};

export default dealershipDomains;
